(function () {
  /* Données de séquence de démonstration */
  /* Chorégraphie en 7 temps : 6 mesures puis le texte défilant.
     Chaque entrée : [valeur, tendance, sprite] — sprite = index dans SPRITES
     (0 cœur, 1 fleur, 2 jus), -1 hors zone cible.
     1 cible + jus        → "personnalisable"
     2 haut (jaune)       → "luminosité réglable"
     3 bas (hypo)         → "alerte sonore"
     4 cible + fleur      → "personnalisable"
     5 tresHaut (rouge)   → cotation "20 cm"
     6 cible + cœur       → "personnalisable"
     7 texte défilant     → aucune annotation */
  var SEQUENCE = [
    [142, 'stable',         2],
    [206, 'monteVite',     -1],
    [62,  'baisseTresVite', -1],
    [128, 'monteVite',      1],
    [288, 'monteTresVite', -1],
    [116, 'baisseVite',     0]
  ];
  var COLS = 32, ROWS = 8, HAUT_GLYPHE = 1;
  var CHIFFRES = {
    0: ['XXX','X.X','X.X','X.X','XXX'], 1: ['.X','XX','.X','.X','.X'],
    2: ['XXX','..X','XXX','X..','XXX'], 3: ['XXX','..X','.XX','..X','XXX'],
    4: ['X.X','X.X','XXX','..X','..X'], 5: ['XXX','X..','XXX','..X','XXX'],
    6: ['XXX','X..','XXX','X.X','XXX'], 7: ['XXX','..X','..X','..X','..X'],
    8: ['XXX','X.X','XXX','X.X','XXX'], 9: ['XXX','X.X','XXX','..X','XXX'],
    '.': ['.','.','.','.','X']
  };
  var LETTRES = {
    A: ['XXX','X.X','XXX','X.X','X.X'], B: ['XX.','X.X','XX.','X.X','XX.'], C: ['XXX','X..','X..','X..','XXX'],
    D: ['XX.','X.X','X.X','X.X','XX.'], E: ['XXX','X..','XX.','X..','XXX'], F: ['XXX','X..','XX.','X..','X..'],
    G: ['XXX','X..','X.X','X.X','XXX'], H: ['X.X','X.X','XXX','X.X','X.X'], I: ['X','X','X','X','X'],
    J: ['..X','..X','..X','X.X','XXX'], K: ['X.X','X.X','XX.','X.X','X.X'], L: ['X..','X..','X..','X..','XXX'],
    M: ['X...X','XX.XX','X.X.X','X...X','X...X'], N: ['X..X','XX.X','X.XX','X..X','X..X'], O: ['XXX','X.X','X.X','X.X','XXX'],
    P: ['XXX','X.X','XXX','X..','X..'], Q: ['XXX','X.X','X.X','XXX','..X'], R: ['XX.','X.X','XX.','X.X','X.X'],
    S: ['XXX','X..','XXX','..X','XXX'], T: ['XXX','.X.','.X.','.X.','.X.'], U: ['X.X','X.X','X.X','X.X','XXX'],
    V: ['X.X','X.X','X.X','X.X','.X.'], W: ['X...X','X...X','X.X.X','XX.XX','X...X'], X: ['X.X','X.X','.X.','X.X','X.X'],
    Y: ['X.X','X.X','.X.','.X.','.X.'], Z: ['XXX','..X','.X.','X..','XXX']
  };
  var HAUTF = ['..X..','.XXX.','X.X.X','..X..','..X..'];
  var BASF   = HAUTF.slice().reverse();
  var DIAGH  = ['.XXXX','...XX','..X.X','.X..X','X....'];
  var COEUR  = ['.XX.XX.','XXXXXXX','XXXXXXX','.XXXXX.','..XXX..','...X...'];
  var FLEUR  = ['..RPR..','..PYP..','..RPR..','...G...','..GG...','...GG..','...G...'];
  FLEUR.haut = -1;
  var JUS    = ['.BBB...','...B...','.GGGGG.','.GGYGG.','.GRRRG.','.GRRRG.','.GRRRG.','.GGGGG.'];
  JUS.haut   = -1;
  var SPRITES = [COEUR, FLEUR, JUS];
  var TEINTES = { X: 'h', R: 'h', P: 'r', Y: 'j', G: 'v', B: 'b' };
  var COEUR_X = 1;
  var FLECHES = {
    stable:         [['..X..','...X.','XXXXX','...X.','..X..']],
    monte:          [DIAGH],
    baisse:         [DIAGH.slice().reverse()],
    monteVite:      [HAUTF],
    baisseVite:     [BASF],
    monteTresVite:  [HAUTF, HAUTF],
    baisseTresVite: [BASF, BASF]
  };
  var MGDL_PAR_MMOL = 18.016;
  var SEUIL_BAS = 70, SEUIL_HAUT = 180, SEUIL_TRES_HAUT = 250;
  var COULEURS = { bas: '#ff3b30', cible: '#2fe35b', haut: '#ffd60a', tresHaut: '#ff3b30' };

  function zone(v) {
    if (v < SEUIL_BAS)   return 'bas';
    if (v <= SEUIL_HAUT) return 'cible';
    if (v <= SEUIL_TRES_HAUT) return 'haut';
    return 'tresHaut';
  }

  function init(racine) {
    /* ── Config depuis data-* attributes ─────────────────────── */
    var DUREE              = parseInt(racine.getAttribute('data-duree'), 10) || 1900;
    var DEFILE_TEXTE       = racine.getAttribute('data-defile-texte') || '';
    var DEFILE_COULEUR     = racine.getAttribute('data-defile-couleur') || '#22d3ee';
    var VALEURS_PAR_ARG    = parseInt(racine.getAttribute('data-valeurs-par-argument'), 10) || 2;
    var DEFILE_ALLERS      = parseInt(racine.getAttribute('data-defile-allers'), 10) || 2;
    var DEFILE_VITESSE     = parseInt(racine.getAttribute('data-defile-vitesse'), 10) || 100;
    var RECEPTION_DELAI    = parseInt(racine.getAttribute('data-reception-delai'), 10) || 380;
    var UNITE_DEPART       = racine.getAttribute('data-unite-depart') || 'mgdl';

    /* ── Sélecteurs ──────────────────────────────────────────── */
    var grille    = racine.querySelector('.sb-grid');
    var bulle     = racine.querySelector('.sb-bulle');
    var boitier   = racine.querySelector('.sb-device');
    var ANGLES    = { stable: 0, monte: -45, baisse: 45, monteVite: -90, baisseVite: 90, monteTresVite: -90, baisseTresVite: 90 };
    var FIN = 0.58, BISEAU = 34, COUCHES = 48, PAS = 0.29;

    /* ── Couches de profondeur ───────────────────────────────── */
    for (var k = COUCHES; k >= 1; k--) {
      var ep = document.createElement('div');
      ep.className = 'sb-ep' + (k === COUCHES ? ' sb-ombre' : '');
      var gris = Math.round(228 - k * 0.75);
      ep.style.background = 'rgb(' + gris + ',' + (gris + 3) + ',' + (gris + 8) + ')';
      ep.style.transform   = 'translateZ(' + (-k * PAS).toFixed(2) + 'cqw)';
      var t = (k / COUCHES - FIN) / (1 - FIN);
      if (t > 0) ep.style.top = (t * BISEAU).toFixed(1) + '%';
      boitier.insertBefore(ep, boitier.firstChild);
    }

    /* Face du dessous */
    var dessous = document.createElement('div');
    dessous.className = 'sb-dessous';
    dessous.style.height = (COUCHES * PAS).toFixed(2) + 'cqw';
    function lignes(l) { return l.map(function (w) { return '<i class="sb-l" style="width:' + w + '%"></i>'; }).join(''); }
    var qr = '', graine = 11;
    for (var q = 0; q < 49; q++) {
      var qx = q % 7, qy = Math.floor(q / 7);
      var coin = (qx < 2 && qy < 2) || (qx > 4 && qy < 2) || (qx < 2 && qy > 4);
      graine = (graine * 16807) % 2147483647;
      qr += '<i' + (coin || graine % 100 < 45 ? ' class="sb-on"' : '') + '></i>';
    }
    dessous.innerHTML =
      '<span class="sb-pied"></span>' +
      '<div class="sb-col"><b class="sb-nom">sugarboard<sup>™</sup></b>' + lignes([30, 0, 90, 78, 86, 70, 82, 52]) + '</div>' +
      '<div class="sb-col"><i class="sb-l sb-titre" style="width:38%"></i>' + lignes([96, 88, 94, 70, 92, 84, 97, 76, 90, 55]) + '</div>' +
      '<div class="sb-col"><i class="sb-l sb-titre" style="width:52%"></i>' + lignes([94, 90, 76, 96, 85, 92, 70, 95, 88, 62]) + '</div>' +
      '<div class="sb-qr">' + qr + '</div>' +
      '<span class="sb-pied"></span>';
    boitier.appendChild(dessous);

    /* Face du dessus */
    var dessus = document.createElement('div');
    dessus.className  = 'sb-dessus';
    dessus.style.height = (COUCHES * PAS * FIN).toFixed(2) + 'cqw';
    dessus.innerHTML  = '<i class="sb-rond"></i>' +
      '<span class="sb-touches"><i class="sb-g"></i><i class="sb-o"></i><i class="sb-d"></i></span>';
    boitier.appendChild(dessus);

    /* ── Rotation 3D ─────────────────────────────────────────── */
    var ANGLE = 24, PERIODE = 10000, MAX_Y = 55, MAX_X = 25, MAX_DESSOUS = 60;
    var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ry = -ANGLE, rx = -3, tenu = false, capturé = false, px = 0, py = 0;
    function poser() {
      boitier.style.transform = 'perspective(3200px) rotateY(' + ry.toFixed(2) + 'deg) rotateX(' + rx.toFixed(2) + 'deg)';
    }
    function borne(v, m) { return Math.max(-m, Math.min(m, v)); }
    boitier.addEventListener('pointerdown', function (e) {
      tenu = true; capturé = false; px = e.clientX; py = e.clientY;
      boitier.classList.add('sb-tenu');
    });
    boitier.addEventListener('pointermove', function (e) {
      if (!tenu) return;
      if (!capturé && boitier.setPointerCapture) {
        boitier.setPointerCapture(e.pointerId);
        capturé = true;
      }
      ry = borne(ry + (e.clientX - px) * 0.35, MAX_Y);
      rx = Math.max(-MAX_X, Math.min(MAX_DESSOUS, rx - (e.clientY - py) * 0.3));
      px = e.clientX; py = e.clientY;
      poser();
    });
    function lacher() { tenu = false; capturé = false; boitier.classList.remove('sb-tenu'); }
    boitier.addEventListener('pointerup', lacher);
    boitier.addEventListener('pointercancel', lacher);
    var rafId = null;
    function boucle(t) {
      if (!document.contains(racine)) { rafId = null; return; }
      if (!tenu) {
        var cibleY = calme ? -ANGLE : -ANGLE * Math.cos(t / PERIODE * 2 * Math.PI);
        ry += (cibleY - ry) * 0.05;
        rx += (-3 - rx) * 0.05;
        poser();
      }
      rafId = requestAnimationFrame(boucle);
    }

    /* ── Pixels ──────────────────────────────────────────────── */
    var pixels = [];
    for (var i = 0; i < COLS * ROWS; i++) {
      var p = document.createElement('div');
      p.className = 'sb-px';
      p.style.transitionDelay = (i % COLS) * 7 + 'ms';
      grille.appendChild(p);
      pixels.push(p);
    }

    /* ── Interaction utilisateur : bloque le défilement ─────── */
    var interacting = false, timerInteraction = null;
    function marquerInteraction() {
      interacting = true;
      if (timerInteraction) clearTimeout(timerInteraction);
      timerInteraction = setTimeout(function () { interacting = false; }, 5000);
    }

    /* ── Switch mg/dL ↔ mmol/L ───────────────────────────────── */
    var unite = UNITE_DEPART, dernier = SEQUENCE[0];
    var boutons = racine.querySelectorAll('.sbx-switch button');
    function choisirUnite(u) {
      marquerInteraction();
      unite = u;
      racine.classList.toggle('sbx-mmol', u === 'mmol');
      for (var n = 0; n < boutons.length; n++)
        boutons[n].setAttribute('aria-pressed', String(boutons[n].getAttribute('data-u') === u));
      afficher(dernier[0], dernier[1]);
    }
    for (var n = 0; n < boutons.length; n++)
      (function (btn) { btn.addEventListener('click', function () { choisirUnite(btn.getAttribute('data-u')); }); })(boutons[n]);

    /* ── Arguments (rendus par Liquid, lus depuis le DOM) ────── */
    var zoneArgs   = racine.querySelector('.sbx-args');
    var zonePoints = racine.querySelector('.sbx-points');
    var args   = zoneArgs   ? Array.prototype.slice.call(zoneArgs.querySelectorAll('.sbx-arg')) : [];
    var points = [];
    var argActif = -1, compte = 0;

    /* Création des spans mot-par-mot (titre) + boutons de navigation */
    args.forEach(function (arg, k) {
      var titreEl = arg.querySelector('.sbx-titre');
      if (titreEl && !titreEl.querySelector('.sbx-m')) {
        var texte = titreEl.textContent.trim();
        titreEl.innerHTML = '';
        texte.split(' ').forEach(function (mot, m) {
          var sp = document.createElement('span');
          sp.className = 'sbx-m'; sp.style.setProperty('--i', m); sp.textContent = mot;
          titreEl.appendChild(sp); titreEl.appendChild(document.createTextNode(' '));
        });
      }
      if (zonePoints) {
        var pt = document.createElement('button'); pt.type = 'button';
        pt.setAttribute('aria-label', 'Argument ' + (k + 1));
        (function (k) { pt.addEventListener('click', function () { naviguerArg(k); }); })(k);
        zonePoints.appendChild(pt); points.push(pt);
      }
    });

    /* ── Swipe tactile sur les arguments ────────────────────── */
    if (zoneArgs && args.length > 1) {
      var touchX = 0;
      zoneArgs.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX;
      }, { passive: true });
      zoneArgs.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) < 40) return;
        naviguerArg((argActif + (delta < 0 ? 1 : -1) + args.length) % args.length);
      });
    }

    requestAnimationFrame(function () {
      if (!zoneArgs || !args.length) return;
      var max = 0;
      args.forEach(function (arg) { if (arg.offsetHeight > max) max = arg.offsetHeight; });
      if (max > 0) zoneArgs.style.height = max + 'px';
    });

    /* Les deux timers sont suivis puis annulés à chaque appel : sans ça, une
       navigation rapide pouvait laisser 'on' et 'sort' simultanément sur un
       argument (même spécificité CSS → 'sort' gagne, l'argument reste masqué). */
    var tArgOn = null, tArgSort = null;
    function montrerArg(k) {
      if (k === argActif || !args.length) return;
      var ancien = args[argActif];
      if (tArgOn)   { clearTimeout(tArgOn);   tArgOn = null; }
      if (tArgSort) { clearTimeout(tArgSort); tArgSort = null; }
      if (ancien) { ancien.classList.remove('on'); ancien.classList.add('sort'); }
      argActif = k;
      points.forEach(function (pt, m) { pt.setAttribute('aria-current', String(m === k)); });
      tArgOn = setTimeout(function () {
        tArgOn = null;
        if (argActif !== k) return;
        args[k].classList.remove('sort');
        args[k].classList.add('on');
      }, ancien ? 320 : 0);
      if (ancien) tArgSort = setTimeout(function () {
        tArgSort = null;
        for (var m = 0; m < args.length; m++)
          if (m !== argActif) args[m].classList.remove('sort');
      }, 750);
    }

    /* Navigation manuelle : marque l'interaction (bloque le texte défilant) et
       réarme l'intervalle, sinon l'avance auto pouvait déclencher juste après. */
    function naviguerArg(k) {
      marquerInteraction();
      compte = 1;
      montrerArg(k);
      if (minuterie) { clearInterval(minuterie); minuterie = setInterval(suivant, DUREE); }
    }

    /* ── Rendu matrice ───────────────────────────────────────── */
    function peindre(etat) {
      for (var i = 0; i < pixels.length; i++) {
        var cls = 'sb-px' + (etat[i] ? ' ' + etat[i] : '');
        if (pixels[i].className !== cls) pixels[i].className = cls;
      }
    }

    /* ── Texte défilant ──────────────────────────────────────── */
    var defilement = false, minuterieDefile = null;
    function finDefile() {
      clearInterval(minuterieDefile); minuterieDefile = null; defilement = false;
      grille.classList.remove('sb-defile');
    }
    function defiler() {
      if (!DEFILE_TEXTE || interacting) return;
      var colonnes = [];
      DEFILE_TEXTE.toUpperCase().split('').forEach(function (c) {
        var g = LETTRES[c] || CHIFFRES[c];
        if (g) {
          for (var col = 0; col < g[0].length; col++) {
            var allumes = [];
            for (var r = 0; r < g.length; r++) if (g[r].charAt(col) === 'X') allumes.push(r);
            colonnes.push(allumes);
          }
          colonnes.push([]);
        } else { colonnes.push([], []); }
      });
      defilement = true;
      grille.classList.add('sb-defile');
      racine.style.setProperty('--c', DEFILE_COULEUR);
      racine.classList.remove('sb-cible'); racine.classList.remove('sb-jaune'); racine.classList.remove('sb-alarme'); racine.classList.remove('sb-mesure');
      while (colonnes.length && !colonnes[colonnes.length - 1].length) colonnes.pop();
      colonnes.unshift([]); colonnes.push([]);
      var fin = COLS - colonnes.length, trajet = [], kk, nn;
      if (fin >= 0) { for (nn = 0; nn < 24; nn++) trajet.push(Math.floor(fin / 2)); }
      else {
        trajet.push(0);
        for (var a = 0; a < DEFILE_ALLERS; a++) {
          for (kk = -1; kk >= fin; kk--) trajet.push(kk);
          for (kk = fin + 1; kk <= 0; kk++) trajet.push(kk);
        }
      }
      var etape = 0;
      function imageD() {
        if (etape >= trajet.length) { finDefile(); afficher(dernier[0], dernier[1]); return; }
        var x = trajet[etape++], etat = new Array(COLS * ROWS);
        for (var kk = 0; kk < colonnes.length; kk++) {
          var cx = x + kk;
          if (cx < 0 || cx >= COLS) continue;
          for (var mm = 0; mm < colonnes[kk].length; mm++)
            etat[(colonnes[kk][mm] + HAUT_GLYPHE) * COLS + cx] = 't';
        }
        peindre(etat);
      }
      imageD();
      minuterieDefile = setInterval(imageD, DEFILE_VITESSE);
    }

    /* ── Affichage glycémie ──────────────────────────────────── */
    var numSprite = -1, timerMatrice = null;
    function afficher(valeur, tendance, delai) {
      if (timerMatrice) { clearTimeout(timerMatrice); timerMatrice = null; }
      if (!defilement) grille.classList.remove('sb-defile');
      var glyphes = [];
      var mmol = unite === 'mmol', lu = mmol ? (valeur / MGDL_PAR_MMOL).toFixed(1) : String(valeur);
      dernier = [valeur, tendance];
      lu.split('').forEach(function (c) { glyphes.push({ m: CHIFFRES[c], t: 'd', esp: 1 }); });
      (FLECHES[tendance] || FLECHES.stable).forEach(function (f) { glyphes.push({ m: f, t: 'a', esp: 0 }); });
      var largeur = 0;
      glyphes.forEach(function (g) { largeur += g.m[0].length + g.esp; });
      var x = Math.floor((COLS - largeur) / 2) + 1;
      if (zone(valeur) === 'cible') {
        var debut = COEUR_X + COEUR[0].length;
        x = debut + Math.max(3, Math.floor((COLS - debut - largeur) / 2));
      }
      var etat = new Array(COLS * ROWS);
      glyphes.forEach(function (g) {
        for (var r = 0; r < g.m.length; r++)
          for (var c = 0; c < g.m[r].length; c++)
            if (g.m[r].charAt(c) === 'X') etat[(r + HAUT_GLYPHE) * COLS + x + c] = g.t;
        x += g.m[0].length + g.esp;
      });
      if (zone(valeur) === 'cible' && numSprite >= 0) {
        var sprite = SPRITES[numSprite];
        for (var hr = 0; hr < sprite.length; hr++)
          for (var hc = 0; hc < sprite[hr].length; hc++) {
            var teinte = TEINTES[sprite[hr].charAt(hc)];
            if (teinte) etat[(hr + HAUT_GLYPHE + (sprite.haut || 0)) * COLS + COEUR_X + hc] = teinte;
          }
      }
      var z = zone(valeur);
      function majMatrice() {
        if (defilement) return;
        peindre(etat);
        racine.style.setProperty('--c', COULEURS[z]);
        /* Les trois états sont exclusifs, un seul pilote une annotation :
           cible → "personnalisable", haut → "luminosité réglable",
           bas ou tresHaut → "alerte sonore". */
        racine.classList.toggle('sb-cible',  z === 'cible');
        racine.classList.toggle('sb-jaune',  z === 'haut');
        racine.classList.toggle('sb-alarme', z === 'bas');
        racine.classList.toggle('sb-mesure', z === 'tresHaut');
      }
      function majBulle() {
        if (!bulle) return;
        bulle.querySelector('.sb-val').textContent = lu.replace('.', ',');
        var uniteEl = bulle.querySelector('.sb-unite');
        if (uniteEl) uniteEl.textContent = mmol ? 'mmol/L' : 'mg/dL';
        bulle.style.setProperty('--a', (ANGLES[tendance] || 0) + 'deg');
        bulle.classList.toggle('sb-double', /TresVite$/.test(tendance));
      }
      if (delai) timerMatrice = setTimeout(function () { timerMatrice = null; majMatrice(); majBulle(); }, delai);
      else { majMatrice(); majBulle(); }
    }

    /* ── Séquence ────────────────────────────────────────────── */
    var index = 0, minuterie = null;
    function suivant() {
      if (args.length && compte % VALEURS_PAR_ARG === 0) montrerArg((argActif + 1) % args.length);
      compte++;
      if (defilement) return;
      /* 7e temps : après la dernière mesure, le texte défilant, puis retour
         à la première. Si l'utilisateur interagit, on saute le défilement
         plutôt que de perdre le tick. */
      if (index >= SEQUENCE.length) {
        index = 0;
        if (DEFILE_TEXTE && !interacting) { defiler(); return; }
      }
      var s = SEQUENCE[index];
      numSprite = s[2];
      racine.classList.remove('sb-recu'); void racine.offsetWidth; racine.classList.add('sb-recu');
      afficher(s[0], s[1], RECEPTION_DELAI);
      /* Pas de modulo : index doit atteindre SEQUENCE.length pour que le
         7e temps (défilement) se déclenche ; c'est lui qui remet à 0. */
      index++;
    }
    /* ── Rotation des capteurs CGM ───────────────────────────── */
    /* Intégré ici (et non dans un <script> inline de la section) pour être
       scopé à cette racine et suivre le cycle de vie de l'IntersectionObserver. */
    var ROTATION_CAP = 5700;
    var capImgs = racine.querySelectorAll('.cap-img');
    var capNom  = racine.querySelector('.cap-nom');
    var capActif = 0, minuterieCap = null;
    function allerCap(pas, manuel) {
      capImgs[capActif].classList.remove('on');
      capActif = (capActif + pas + capImgs.length) % capImgs.length;
      capImgs[capActif].classList.add('on');
      if (capNom) capNom.textContent = capImgs[capActif].getAttribute('data-nom');
      if (manuel && racine._sbPointsSuspension) racine._sbPointsSuspension();
    }
    function relancerCap() {
      clearInterval(minuterieCap);
      minuterieCap = setInterval(function () { allerCap(1); }, ROTATION_CAP);
    }
    if (capImgs.length > 1) {
      var capPrec = racine.querySelector('.cap-prec');
      var capSuiv = racine.querySelector('.cap-suiv');
      if (capPrec) capPrec.addEventListener('click', function () { allerCap(-1, true); relancerCap(); });
      if (capSuiv) capSuiv.addEventListener('click', function () { allerCap(1, true);  relancerCap(); });
    }

    /* ── Démarrage / arrêt (piloté par l'IntersectionObserver) ── */
    function demarrer() {
      if (!minuterie) { suivant(); minuterie = setInterval(suivant, DUREE); }
      if (!rafId) rafId = requestAnimationFrame(boucle);
      if (capImgs.length > 1 && !minuterieCap) relancerCap();
      racine.classList.add('sb-anime');
    }
    function arreter() {
      clearInterval(minuterie); minuterie = null;
      clearInterval(minuterieCap); minuterieCap = null;
      if (defilement) finDefile();
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      if (timerMatrice) { clearTimeout(timerMatrice); timerMatrice = null; }
      racine.classList.remove('sb-anime');
    }

    /* ── API externe : capteur changé manuellement → "···" cyan */
    racine._sbPointsSuspension = function () {
      marquerInteraction();
      if (defilement) finDefile();
      if (timerMatrice) { clearTimeout(timerMatrice); timerMatrice = null; }
      var etat = new Array(COLS * ROWS);
      [14, 16, 18].forEach(function (x) {
        etat[4 * COLS + x] = 't';
      });
      racine.style.setProperty('--c', DEFILE_COULEUR);
      racine.classList.remove('sb-cible'); racine.classList.remove('sb-jaune'); racine.classList.remove('sb-alarme'); racine.classList.remove('sb-mesure');
      grille.classList.add('sb-defile');
      peindre(etat);
      timerMatrice = setTimeout(function () {
        timerMatrice = null;
        grille.classList.remove('sb-defile');
        afficher(dernier[0], dernier[1]);
      }, 650);
    };

    choisirUnite(UNITE_DEPART);
    if ('IntersectionObserver' in window) {
      var observateur = new IntersectionObserver(function (e) {
        /* Section retirée du DOM (rechargement de section dans l'éditeur) :
           on arrête tout et on libère l'observer, sinon il retient un nœud détaché. */
        if (!document.contains(racine)) { arreter(); observateur.disconnect(); return; }
        if (e[0].isIntersecting) demarrer(); else arreter();
      }, { threshold: 0.2 });
      observateur.observe(racine);
    } else { demarrer(); }

    /* ── Éditeur Shopify : sélection d'un bloc argument ─────── */
    document.addEventListener('shopify:block:select', function onBS(e) {
      if (!document.contains(racine)) { document.removeEventListener('shopify:block:select', onBS); return; }
      var el = racine.querySelector('[data-block-id="' + e.detail.blockId + '"]');
      if (!el) return;
      var k = args.indexOf(el);
      if (k !== -1) naviguerArg(k);
    });
  }

  /* ── Initialisation ──────────────────────────────────────── */
  function initAll() {
    var blocs = document.querySelectorAll('[data-sb]:not([data-sb-init])');
    for (var b = 0; b < blocs.length; b++) {
      blocs[b].setAttribute('data-sb-init', '1');
      init(blocs[b]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var blocs = e.target.querySelectorAll('[data-sb]');
    for (var b = 0; b < blocs.length; b++) {
      if (!blocs[b].hasAttribute('data-sb-init')) {
        blocs[b].setAttribute('data-sb-init', '1');
        init(blocs[b]);
      }
    }
  });
})();
